<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="page_22"></a><a id="sec5"></a>Untitled # 70 (Or, The Question of Remains)</h4>
<p class="poem">The day she put on her glitz teardrops<br/>and O Hon lip gloss,<br/>ate an orange on an empty<br/>and took the 8-train<br/>to Grackleville, she met a man<br/>climbing a narrow stairwell,<br/>repeating to himself, This is all, this is all.<br/>The music of a popular march played<br/>in his head. This, he said, is all,<br/>directing any further comment<br/>to a longtime opposition blooming in his chest.<br/>No, he said, to the offer<br/>of a chaotic labyrinth of clouds,<br/>devotion, rain, creatures of fables,<br/>and opulent solitude.<br/>Alone he entered the thicket<br/>of empty situations, the rhetorical force<br/>of conversation,<br/>muttering as he went, This is all—</p>
<p class="poem">Apprentice to death. Toxic grace.<br/>Terrible and beautiful repose.<br/>Dismay and murkiest waters.<br/>The blighted morning.<br/>The coordinate night.<br/>The sad fact of the pink glow<br/>of Grackleville’s late iridescence.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_b.vue?3ce41191